@if (time) {
  <span [title]="formattedTitle">
    {{ formattedTime }}
  </span>
} @else {
  -
}
